export const getUserProfileForCompany = (companyId: string, userProfileId: string) => {
  return `/companies/${companyId}/user_profiles/${userProfileId}`;
};

export const listNotificationsForUserProfile = (companyId: string, userProfileId: string) => {
  return `/companies/${companyId}/user_profiles/${userProfileId}/notifications`;
};
